module.exports = __webpack_public_path__ + "static/media/Orcamentos8.e008eb6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrcamentos/Orcamentos8.png
// module id = 2104
// module chunks = 0